<template>
    <div class="detail-box">
        <div class="detail-header HeaderBar index_border" :class='{ active: active }'>
            <div class="index-header-main" @click="changeSidebar()">
                <i v-show="!main" class="iconfont x-a-maenbtn"></i>
                <i v-show="main" class="iconfont x-a-maenbtnx"></i>
            </div>
            <div class="detail-header-logo">
                <div v-show="zhactive">
                    <img v-show="imgactive" src="@/assets/images/index-svg-white.svg" alt="">
                    <img v-show="!imgactive" src="@/assets/images/index-svg-black.svg" alt="">
                </div>
                <div v-show="enactive">
                    <img v-show="imgactive" src="@/assets/images/index-svg-white-en.svg" alt="">
                    <img v-show="!imgactive" src="@/assets/images/index-svg-black-en.svg" alt="">
                </div>
            </div>
            <div class="detail-header-En">
                <span v-show="skill">技术支持</span>
                <span class="spancolor indexspancolor" :class='{ spanactive: zhactive }'
                    @click="setLanguage('zh')">中文</span>
                <span><el-divider content-position="center" direction="vertical"></el-divider></span>
                <span class="spancolor indexspancolor" :class='{ spanactive: enactive }'
                    @click="setLanguage('en')">EN</span>
            </div>
        </div>
        <div class="detail-aside AsideBar" :class="{ AsideBaractive: mianOpen }">
            <div class="HeaderI"></div>
            <div class="Sider">
                <ul class="Sider-ul">
                    <li class="Sider-ul-li" v-for="(item, i) in list" :key='i' @click="tochangeli(item)">
                        <span class="spanul">{{ $t(item.name) }}</span><span class="spanul2" v-show="i == 1"></span>
                        <ul :class='{ active: item.show === true }' :ref="`list${i}`">
                            <li v-for="(a, index) in item.list" :key="index" @click.stop="doThis(a)">
                                <span v-show="zhactive" class="spanli">{{ a.name }}</span>
                                <span v-show="enactive" class="spanli">{{ a.name_en }}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
                <div class="AsideBar-bottom">
                    <span class="spancolor" :class='{ spanactive: zhactive }' @click="setLanguage('zh')">中文</span>
                    <span class="spancolor" :class='{ spanactive: enactive }' @click="setLanguage('en')">EN</span>
                </div>
            </div>
        </div>
        <div class="index-sider">
            <div class="HeaderI"></div>
            <div class="Sider">
                <ul class="Sider-ul">
                    <li class="Sider-ul-li" v-for="(item, i) in list" :key='i' @click="tochangeli(item)">
                        <span class="spanul">{{ $t(item.name) }}</span> &nbsp; <span class="spanul2"
                            v-show="i == 1"></span>
                        <ul :class='{ active: item.show === true }' :ref="`listlg${i}`">
                            <li v-for="(a, index) in item.list" :key="index" @click.stop="doThis(a)">
                                <span v-show="zhactive" class="spanli">{{ a.name }}</span>
                                <span v-show="enactive" class="spanli">{{ a.name_en }}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <!-- <div class="videoBox"> -->
        <div class="video-home">
            <div class="video-home-bg"></div>
            <div class="video-home-btn" @click="pausevideo">
                <i v-show="videoopen" class="iconfont x-pause"></i>
                <i v-show="!videoopen" class="iconfont x-play"></i>
            </div>
            <div class="video-box">
                <video ref="video" autoplay muted loop preload="auto" webkit-playsinline='true' playsinline="true"
                    x5-playsinline="true" x-webkit-airplay="true" x5-video-player-type="h5"
                    x5-video-player-fullscreen="true" x5-video-ignore-metadata="true" x5-video-orientation="landscape">

                    <source src="../../assets/video/index.mp4" type='video/mp4; codecs="avc1.4D401E, mp4a.40.2"'>
                </video>
            </div>
        </div>
        <div class="common-width">
            <div class="Bottom">
                <div class="Bottom-list">
                    <div v-for="(item, i) in icons" @click="iconto(i)" :key="i" @mouseenter="mouseEnter(i)"
                        @mouseleave="mouseLeave(i)">
                        <a href="javascript:;">
                            <i class="derail-center-right-mean-i" :class="'iconfont' + ` ${item}`">
                                <div class="box-Bottom" :class="{ bottomLi: i == idxi && i == 0 }">
                                    <div class="Triangle-down"></div>
                                    <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
                                    <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
                                </div>
                            </i>
                        </a>
                    </div>
                    <!-- <share :config='config'></share> -->
                </div>
                <div class="Bottom-divider">
                    <el-divider></el-divider>
                </div>
                <div class="Bottom-icp">
                    <div><a href="javascript">{{ $t('lang.Record_1') }}</a></div>
                    <div><a href="https://beian.miit.gov.cn" target="_blank">{{ $t('lang.Record_2') }}</a></div>
                    <div class="b_span">
                        <img src="@/assets/images/logo-police.png" alt="">
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44040402000338" rel="noreferrer"
                            target="_blank">粤公网安备44040402000338号</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- </div> -->

        <div class="BottomLeft">
            <div class="BottomLeft-box">
                <div class="BottomLeft-list index-BottomLeft">
                    <div v-for="(item, i) in icons" :key="i" @click="iconto(i)" @mouseenter="mouseEnter(i)"
                        @mouseleave="mouseLeave(i)">
                        <a href="javascript:;">
                            <i class="derail-center-right-mean-i" :class="'iconfont' + ` ${item}`">
                                <div class="box-Bottom" :class="{ bottomLi: i == idxi && i == 0 }">
                                    <div class="Triangle-down"></div>
                                    <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
                                    <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
                                </div>
                            </i>
                        </a>
                    </div>
                    <!-- <share class="share-color" :config='config'></share> -->
                </div>
                <div class="BottomLeft-icp index-BottomLeft">
                    <div><a href="javascript:;">{{ $t('lang.Record_1') }}</a></div>
                    <!-- <div>&nbsp;&nbsp;&nbsp;</div> -->
                    <div><a href="https://beian.miit.gov.cn" target="_blank">{{ $t('lang.Record_2') }}</a></div>
                    <div class="b_span">
                        <img src="@/assets/images/logo-police.png" alt="">
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44040402000338" rel="noreferrer"
                            target="_blank">粤公网安备44040402000338号</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="all-center" :class="{ openicon: openicon }">
            <div class="all-center-box" @click="changeiconto"></div>
            <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
            <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
        </div>
    </div>
</template>
<script>
import { product, faqsList } from "@/api/index";
import { mapGetters } from "vuex"
import { Localurl } from "@/utils/validate"
export default {
    name: 'index',
    computed: {
        ...mapGetters(["languageType"])
    },
    components: {
    },
    data() {
        return {
            idxi: -1,
            imgactive: true,
            mianOpen: false,
            main: false,
            active: false,
            zhactive: true,
            enactive: false,
            skill: false,
            headerbarlistactive: true,
            videoopen: true,
            openicon: false,
            windowinnerWidth: false,
            list: [
                { name: 'lang.index_li1', url: { name: '/detail', open: true }, list: [], show: false, active: false },
                { name: 'lang.index_li2', url: { name: '/list', open: false }, list: [], show: false, active: false },
                { name: 'lang.index_li3', url: { name: '/about', open: true }, list: [], show: false, active: false },
                { name: 'lang.index_li4', url: { name: '/position', open: false }, list: [], show: false, active: false },
                { name: 'lang.index_li5', url: { name: '/callus', open: true }, list: [], show: false, active: false },
            ],
            mainliHeight: 40,
            icons: ['x-wechat', 'x-jd', 'x-tm'],
            config: {
                sites: ['qq', 'wechat', 'linkedin', 'facebook', 'twitter'],
            },
            newIdidx: 0,

        }
    },
    mounted() {
        setTimeout(() => {
            this.active = true
            this.getWidth();
            this.openicon = false;
            this.setLanguage(this.languageType)
            Localurl("?lang=" + this.languageType);
        }, 500)
    },
    methods: {
        changeSidebar() {
            this.main = !this.main
            this.mianOpen = !this.mianOpen
        },
        getWidth() {
            if (window.innerWidth < 468 && this.headerbarlistactive) {
                this.headerbarlistactive = false
                this.imgactive = false

            }
            if (window.innerWidth >= 468 && !this.headerbarlistactive) {
                this.imgactive = true
                this.headerbarlistactive = true
                this.mianOpen = false
                this.main = false
                this.openicon = false
            }
            if (window.innerWidth >= 992) {
                this.windowinnerWidth = false
            } else {
                this.windowinnerWidth = true
            }
        },
        tochangeli(item) {
            console.log(item)
            if (this.$route.path == item.url.name) { return; }
            if (item.url.open) { this.$router.push({ path: item.url.name, query: { lang: this.languageType } }); }
            if (!item.url.open && item.url.name == "/list") { this.$router.push({ path: item.url.name, query: { lang: this.languageType, id: item.list[this.newIdidx].id } }); } else { console.log("走这条"); this.$router.push({ path: item.url.name, query: { lang: this.languageType, id: item.list[0].id } }); }
        },
        // leaveli(index){
        //     this.$refs[`list${index}`][0].style.height = '0'
        //     this.$refs[`listlg${index}`][0].style.height = '0'
        // },
        // enterli(item,index){
        //     this.list.map((i,mapidx)=>{
        //         if(item.show !== i.show){
        //             i.show = false 
        //             this.$refs[`list${mapidx}`][0].style.height = '0'
        //             this.$refs[`listlg${mapidx}`][0].style.height = '0'
        //         }
        //     })
        //     item.show = !item.show;
        //     this.$refs[`list${index}`][0].style.height =this.list[index].list.length * this.mainliHeight +'px';
        //     this.$refs[`listlg${index}`][0].style.height =this.list[index].list.length * this.mainliHeight +'px';
        // },
        doThis(item) {

            if (item.open) { this.$router.push({ path: item.namelink, query: { id: item.id } }); }
        },
        setLanguage(val) {
            this.$store.dispatch("index/language", { lang: val })
            Localurl("?lang=" + this.languageType);
            this.$i18n.locale = val
            if (val == 'zh') {
                this.zhactive = true
                this.enactive = false
                document.title = "X-Speaker"
            } else {
                this.enactive = true
                this.zhactive = false
                document.title = "X-Speaker"
            }
        },
        mouseEnter(i) { this.idxi = i },
        mouseLeave() { this.idxi = -1 },
        pausevideo() {
            if (this.$refs.video.paused) {
                this.$refs.video.play()
                this.videoopen = true;
            } else if (this.$refs.video.play()) {
                this.$refs.video.pause()
                this.videoopen = false;
            }
        },
        iconto(i) {
            if (i === 0 && this.windowinnerWidth) { this.openicon = true }
            if (i === 1) { window.open("https://mall.jd.com/index-12191261.html", "_black") }
            if (i === 2) { window.open("https://x-speaker.tmall.com/?spm=a217wi.openworkbeanchtmall.widgets.2.41e65e16MbeHsw", "_black") }

        },
        changeiconto() { this.openicon = false },
        fetchData() {
            product({ pageSize: 20 }).then((res) => {
                if (res.code == 200) {
                    var newtiems = 0;
                    var data = res.data.list;
                    for (var i = 0; i < data.length; i++) {
                        this.list[1].list.push({
                            name: data[i].name,
                            name_en: data[i].name_en,
                            id: data[i].id,
                            namelink: '/list',
                            open: true,
                        })
                        if (newtiems < data[i].CreatedAt) {
                            newtiems = data[i].CreatedAt
                            this.newIdidx = i
                        }

                    }
                }

            });
            faqsList().then((res) => {
                var data = res.data.list
                for (var i = 0; i < data.length; i++) {
                    this.list[3].list.push({
                        name: data[i].name,
                        name_en: data[i].name_en,
                        id: data[i].id,
                        namelink: '/position',
                        open: true,
                    })
                }
            })
        },
    },
    created() {
        this.fetchData();
        window.addEventListener('resize', this.getWidth);
    },
}
</script>
<style>
.videoBox {
    overflow: hidden;
}

.video-home {
    width: 100%;
    position: relative;
    top: 0;
    left: 0;
    overflow: hidden;
    height: 100vh;
    z-index: 6;
    background-color: #333333;
}

.video-box {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    overflow: hidden;
    z-index: 10;
}

.video-home-btn {
    position: absolute;
    bottom: 36px;
    right: 36px;
    z-index: 11;
    width: 46px;
    height: 46px;
}

.video-home-btn i {
    font-size: 36px;
    cursor: pointer;
}

.video-box video {
    width: 240vh;
    min-width: 100%;
    min-height: 41.66vw;
    position: absolute;
    left: 50%;
    top: 50%;
    background-color: #333333;
    transform: translate(-50%, -50%)
}

.index-header-main i {
    display: none
}

.index_border {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.125);
}

@media (max-width: 1200px) {}

@media (max-width: 992px) {}

@media (max-width: 468px) {
    .detail-aside {
        width: 50%;
        left: -300px;
    }

    .index-sider {
        display: none
    }

    .detail-header-En span {
        display: none
    }

    .index-header-main i {
        display: block;
    }

    .video-home-btn {
        bottom: 15px;
        right: 10px;
    }
}

.index-sider {
    position: fixed;
    left: 0px;
    top: 0;
    z-index: 11;
    color: white;
}

.index-sider .Sider-ul-li:hover span.spanul {
    border-bottom: 1px solid white;
    padding: 0 0 1px 0;
}

.index-sider .Sider-ul-li ul li:hover span.spanli {
    border-bottom: 1px solid white;
    padding: 0 0 1px 0;
}

.index-BottomLeft div a,
.index-BottomLeft div a .derail-center-right-mean-i {
    color: white
}

.index-BottomLeft div a:hover,
.index-BottomLeft a .derail-center-right-mean-i:hover {
    color: #ccc
}

.index-BottomLeft .b_span img {
    width: 13px;
    height: 13px;
    margin: 0 5px 0 10px;
}

.BottomLeft-icp div {
    margin-left: 5px;
}

.indexspancolor {
    color: #999999
}

.indexspancolor.spanactive {
    color: white
}

.detail-header-En>>>.el-divider--vertical {
    margin: -3px 0 0 0;
}

.Bottom-icp {
    display: flex;
    flex-direction: column;
    margin-left: 5px;
}

.b_span img {
    width: 13px;
    height: 13px;
    object-fit: cover;
}
</style>
